<template>
<div v-if="conteudo">
    <template v-for="(pe, iex) in lista_selecionados">
        <div class="form-row" :key="iex">
            <div class="col col-12 col-md-4" v-if="false">
                <az-input
                    type="select"
                    sizing="sm"
                    :optionsList="[
                        { id: 'C', search: 'Classe de Recurso' },
                        { id: 'E', search: 'Recurso Específico' },
                    ]"
                    optionsData="id"
                    :edicao="!cadastro || !pe.id_procedimento_equipamento"
                    required
                    :validate="validate"
                    v-model="pe.st_tipo">
                    <template v-slot:button-pre>
                        <div class="input-group-prepend" v-if="!pe.fl_fixo">
                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="pe.excluido = true">
                                <i class="fa fa-minus" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
            <div class="col col-12"> <!--  col-md-8 -->
                <az-input
                    sizing="sm"
                    v-if="pe.st_tipo == 'C'"
                    type="select"
                    :optionsList="lista_classes_recurso"
                    optionsData="id"
                    :edicao="!cadastro || !pe.id_procedimento_equipamento"
                    required
                    :validate="validate"
                    v-model="pe.st_classe">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="iex === lista_selecionados.length - 1">
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir_recurso()">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>

                <az-input
                    sizing="sm"
                    v-else-if="pe.st_tipo == 'E' && equipamentos"
                    type="select"
                    :optionsList="lista_equipamentos"
                    optionsData2="id_equipamento"
                    :edicao="( !cadastro || !pe.id_procedimento_equipamento ) && !pe.fl_fixo"
                    required
                    :validate="validate"
                    v-model="pe.equipamento">
                    <template v-slot:button-pre>
                        <div class="input-group-prepend" v-if="!pe.fl_fixo && !( procedimento && procedimento.fl_recurso >= 2 && !iex )">
                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="pe.excluido = true">
                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="!pe.fl_fixo && !( procedimento && procedimento.fl_recurso == 3 ) && iex === lista_selecionados.length - 1">
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir_recurso()">
                                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
        </div>
    </template>

    <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir_recurso()" v-if="!lista_selecionados.length">
        <i class="fa fa-plus mr-2" aria-hidden="true"></i>
        Recurso Necessário
    </button>
</div>
</template>

<script>
import _ from 'lodash';
import AzInput from './forms/AzInput.vue';

export default {
    data() {
        return { 
            conteudo: null, 
            opcoes: [], 
        }
    },

    props: ['equipamentos', 'value', 'validate', 'cadastro', 'procedimento'],

    components: { 
        AzInput,
    },

    computed: { 
        lista_equipamentos: function () { 
            if ( this.procedimento && this.procedimento.fl_recurso == 3 && this.opcoes ) { 
                return this.opcoes.map(item => item.equipamento);
            }

            return this.equipamentos;
        },

        lista_selecionados: function () { 
            if ( !this.conteudo )
                return [];

            return this.conteudo.filter(item => !item.excluido);
        },

        lista_classes_recurso: function () { 
            if ( !this.equipamentos ) { 
                return [];
            }

            return _.uniq(
                    this.equipamentos.filter(item => item.js_classes)
                        .flatMap(item => item.js_classes)
                )
                .sort()
                .map(item => { 
                    return { 
                        id: item,
                        search: item,
                    };
                });
        },
    },

    watch: { 
        conteudo: { 
            handler: function (newValue) { 
                this.$emit('input', newValue);
            },
            deep: true, 
        },

        value: {
            handler: function (newValue) {
                this.conteudo = newValue;
            },
            immediate: true,
        },
    },

    methods: { 
        incluir_recurso() { 
            this.conteudo.push({ 
                id_procedimento_equipamento: null, 
                st_tipo: 'E', //  this.lista_classes_recurso.length ? 'C' : 'E', 
                st_classe: "",
                id_equipamento: "", 
                equipamento: "", 
                excluido: false, 
            });

            // this.$emit('input', this.conteudo.procedimento_equipamentos);
            
            /*
            this.$nextTick(() => { 
                this.$forceUpdate();
            });
            */
        },
    },

    mounted() { 
        this.opcoes = _.cloneDeep(this.value);

        if ( this.procedimento && this.procedimento.fl_recurso == 3 ) { 
            this.$nextTick(() => { 
                this.conteudo = this.conteudo.slice(0,1);
            });
        }
    }

}
</script>
